import styled from 'styled-components';

import { Input } from 'antd';


//Changed from: font-weight: 12px, line-height: 15px
export const StyledInput = styled(Input)`
	border-radius: unset;
	
	border: ${(props) => `2px solid ${props.theme.colors.borderColor}`};
	
	padding: 5px;
	
	font-weight: 500;
	font-size: 22px; 
	line-height: 30px;
	height:30px;
	
	&:hover,
	&:focus {
		border-color: ${ props => props.theme.colors.borderColor };
		box-shadow: unset;
	}
`;

export const ValidateMsg = styled.div<{ isError:boolean }>`
	font-weight: 500;
	font-size: 12px;
	line-height: 15px;
	
	color: ${({ isError, theme }: { isError: boolean, theme: any }) =>
		isError ? theme.colors.red : theme.colors.silver };
	
	margin-top: 5px;
	text-align: left;
`;
